// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import classNames from 'classnames';
// import { compose } from 'redux';
// import { withRouter } from 'react-router-dom';

// import { apiBaseUrl } from '../../util/api';
// import { richText } from '../../util/richText';
// import { createSlug } from '../../util/urlHelpers';
// import { ensureListing, ensureUser } from '../../util/data';
// import { lazyLoadWithDimensions } from '../../util/uiHelpers';
// import { createResourceLocatorString } from '../../util/routes';
// import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';

// import {
//   AvatarSmall,
//   AvatarMedium,
//   ResponsiveImage,
//   AspectRatioWrapper,
//   NamedLink,
// } from '../../components';

// import { useConfiguration } from '../../context/configurationContext';
// import { useRouteConfiguration } from '../../context/routeConfigurationContext';

// import css from './ListingCardNew.module.css';

// import { FaStar } from 'react-icons/fa6';
// import { FaRegStar } from 'react-icons/fa6';
// import { GrLocation } from 'react-icons/gr';
// import { AiTwotoneHeart } from 'react-icons/ai';
// import { FaRegStarHalfStroke } from 'react-icons/fa6';
// import { ReactComponent as GlobeSVG } from '../../assets/svg/globe.svg';
// import { ReactComponent as PhoneSVG } from '../../assets/svg/phone.svg';
// import { ReactComponent as VerifiedSVG } from '../../assets/svg/verified.svg';
// import { ReactComponent as WhatsAppSVG } from '../../assets/svg/whats-app.svg';
// import { ReactComponent as GetDirectionSVG } from '../../assets/svg/get-direction.svg';
// import { connect } from 'react-redux';
// import { fetchFavListing } from '../../containers/FavouritesPage/FavouritesPage.duck';
// import { fetchCurrentUser } from '../../ducks/user.duck';

// const DESC_MAX_WORDS = 80;
// const MIN_LENGTH_FOR_LONG_WORDS = 10;

// const renderStars = avgRating => {
//   const stars = [];
//   const halfStar = avgRating % 1 !== 0;
//   const fullStars = Math.floor(avgRating);
//   const emptyStars = 5 - Math.ceil(avgRating);

//   for (let i = 0; i < fullStars; i++) {
//     stars.push(<FaStar key={i} />);
//   }

//   if (halfStar) {
//     stars.push(<FaRegStarHalfStroke key={fullStars} />);
//   }

//   for (let i = 0; i < emptyStars; i++) {
//     stars.push(<FaRegStar key={fullStars + halfStar + i} />);
//   }

//   return stars;
// };

// const LazyImage = lazyLoadWithDimensions(ResponsiveImage, { loadAfterInitialRendering: 3000 });

// export const ListingCardNewComponent = props => {
//   const config = useConfiguration();
//   const routeConfiguration = useRouteConfiguration();
//   const [isFavourite, setIsFavourite] = useState(null);
//   const [favouriteLoading, setFavouriteLoading] = useState('');
//   const {
//     intl,
//     author,
//     history,
//     listing,
//     className,
//     currentUser,
//     renderSizes,
//     rootClassName,
//     showAuthorInfo,
//     setActiveListing,
//     onFetchFavListing,
//     onFetchCurrentUser,
//     favListingsIds,
//   } = props;
//   const classes = classNames(rootClassName || css.root, className);
//   const currentListing = ensureListing(listing);
//   const id = currentListing.id.uuid;

//   // Author details
//   const ensuredAuthor = ensureUser(author);
//   const authorName = ensuredAuthor.attributes.profile.displayName;
//   const ensuredAuthorPublicData = ensuredAuthor?.attributes?.profile?.publicData || {};
//   const isPremiumVendor = ensuredAuthorPublicData?.isPremiumVendor;
//   const services = ensuredAuthorPublicData?.services || [];
//   const websiteLink = ensuredAuthorPublicData.websiteLink;
//   const companyName = ensuredAuthorPublicData.companyName;
//   const isProvider = ensuredAuthorPublicData?.isProvider;
//   const trimmedServices =
//     services?.length > 2 ? services?.slice(0, 2)?.concat({ label: '...' }) : services;

//   const callNumber = ensuredAuthorPublicData?.phoneNumber?.number;
//   const callDialCode = ensuredAuthorPublicData?.phoneNumber?.dialCode;
//   const vendorCallNumber = `${callDialCode}${callNumber}`;
//   const whatsAppNumber = ensuredAuthorPublicData?.alternativePhoneNumber?.number;
//   const whatsAppDialCode = ensuredAuthorPublicData?.alternativePhoneNumber?.dialCode;
//   const vendorWhatsAppNumber = `${whatsAppDialCode}${whatsAppNumber}`;

//   // Listing details
//   const { title = '', publicData, description = '' } = currentListing.attributes;
//   const slug = createSlug(title);
//   const brandName = publicData?.brandName;
//   const address = publicData?.locationFromUser?.selectedPlace?.address;
//   const trimmedDescription =
//     description?.length > DESC_MAX_WORDS
//       ? description.slice(0, DESC_MAX_WORDS) + '...'
//       : description;

//   const firstImage =
//     currentListing.images && currentListing.images.length > 0 ? currentListing.images[0] : null;

//   const {
//     aspectWidth = 1,
//     aspectHeight = 1,
//     variantPrefix = 'listing-card',
//   } = config.layout.listingImage;
//   const variants = firstImage
//     ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith(variantPrefix))
//     : [];

//   const setActivePropsMaybe = setActiveListing
//     ? {
//         onMouseEnter: () => setActiveListing(currentListing.id),
//         onMouseLeave: () => setActiveListing(null),
//       }
//     : null;

//   const toggleFavourites = async e => {
//     e.stopPropagation();
//     setFavouriteLoading(id);
//     const userId = currentUser?.id?.uuid;
//     const toggleUrl = `${apiBaseUrl()}/api/favourites/toggle/${id}`;

//     if (!userId) {
//       return history.push(
//         createResourceLocatorString('LoginPage', routeConfiguration, { tab: 'login' })
//       );
//     }

//     return axios
//       .get(toggleUrl, { withCredentials: true })
//       .then(res => {
//         res.data.message === 'Favourite added' ? setIsFavourite(true) : setIsFavourite(false);
//         setFavouriteLoading('');
//       })
//       .then(() => {
//         onFetchFavListing({ config });
//       })
//       .then(() => {
//         onFetchCurrentUser();
//       })
//       .catch(err => {
//         setFavouriteLoading('');
//       });
//   };

//   const authorContainer = (
//     <div className={css.author}>
//       <div className={css.authorAvatar}>
//         <AvatarSmall
//           user={ensuredAuthor}
//           disableProfileLink={true}
//           className={css.providerAvatarSmall}
//         />
//         <AvatarMedium
//           user={ensuredAuthor}
//           disableProfileLink={true}
//           className={css.providerAvatarMedium}
//         />
//       </div>

//       <div className={css.authorInformation}>
//         {/* Business Name */}
//         <div className={css.authorCompany}>
//           <span>{companyName}</span>
//           {isPremiumVendor && (
//             <React.Fragment>
//               <VerifiedSVG />
//               <span className={css.authorIsVerified}>Verified</span>
//             </React.Fragment>
//           )}
//         </div>

//         {isProvider && websiteLink ? (
//           <div className={css.websiteLink} onClick={e => e.stopPropagation()}>
//             <GlobeSVG
//               onClick={e => {
//                 e.stopPropagation();

//                 if (window) {
//                   window.open(websiteLink, '_blank');
//                 }
//               }}
//             />
//             <a target="_blank" rel="noopener noreferrer" href={websiteLink}>
//               {websiteLink}
//             </a>
//           </div>
//         ) : null}

//         {/* Provider Name */}
//         {!isProvider && authorName && <div className={css.authorName}>{authorName}</div>}

//         {/* Chips */}
//         {services?.length ? (
//           <div className={css.serviceChipContainer}>
//             {/* {Array.from({ length: 12 }, () => trimmedServices).flat().map(service => ( */}
//             {trimmedServices?.map(service => <div key={service?.label}>{service?.label}</div>)}
//           </div>
//         ) : null}
//       </div>
//     </div>
//   );

//   const buttonsContainer = (
//     <div className={css.buttonWrapper}>
//       <button
//         className={css.getDirection}
//         onClick={e => {
//           e.stopPropagation();

//           if (window) {
//             window.open(`https://www.google.com/maps?q=${address}`, '_blank');
//           }
//         }}
//       >
//         <GetDirectionSVG />
//         <FormattedMessage id="ListingCard.getDirectionButton" />
//       </button>

//       <button
//         disabled={!(callDialCode && callNumber)}
//         className={classNames(css.call, {
//           [css.callNotAvailable]: !(callDialCode && callNumber),
//         })}
//         onClick={e => {
//           e.stopPropagation();
//           window.location.href = `tel:${vendorCallNumber}`;
//         }}
//       >
//         <PhoneSVG />
//         {callDialCode && callNumber ? (
//           <a href={`tel:${vendorCallNumber}`} onClick={e => e.stopPropagation()}>
//             {vendorCallNumber}
//           </a>
//         ) : (
//           <FormattedMessage id="ListingCard.callNotAvailableButton" />
//         )}
//       </button>

//       <button
//         disabled={!(whatsAppDialCode && whatsAppNumber)}
//         className={classNames(css.whatsapp, {
//           [css.callNotAvailable]: !(whatsAppDialCode && whatsAppNumber),
//         })}
//         onClick={e => {
//           e.stopPropagation();
//           const message = encodeURIComponent('Hello! I found your business in BizzProfiles');
//           const url = `https://api.whatsapp.com/send?phone=${vendorWhatsAppNumber}&text=${message}`;
//           window.open(url, '_blank', 'noopener noreferrer');
//         }}
//       >
//         <WhatsAppSVG />
//         {whatsAppDialCode && whatsAppNumber ? (
//           <a
//             target="_blank"
//             rel="noopener noreferrer"
//             onClick={e => e.stopPropagation()}
//             href={`https://api.whatsapp.com/send?phone=${vendorWhatsAppNumber}&text=${encodeURIComponent(
//               `Hello! I found your business in BizzProfiles`
//             )}`}
//           >
//             {'WhatsApp'}
//           </a>
//         ) : (
//           <FormattedMessage id="ListingCard.callNotAvailableButton" />
//         )}
//       </button>

//       <button className={css.sendEnquiry}>
//         <FormattedMessage id="ListingCard.sendEnquiryButton" />
//       </button>
//     </div>
//   );

//   useEffect(() => {
//     if (isFavourite === null && currentUser?.id?.uuid) {
//       currentUser.favourites?.includes(id) ? setIsFavourite(true) : setIsFavourite(false);
//     }
//   }, [currentUser]);

//   return (
//     <article
//       className={classes}
//       onClick={e => {
//         history.push(createResourceLocatorString('ListingPage', routeConfiguration, { id, slug }));
//       }}
//     >
//       <section className={css.content}>
//         <AspectRatioWrapper
//           width={aspectWidth}
//           height={aspectHeight}
//           className={css.aspectRatioWrapper}
//           {...setActivePropsMaybe}
//         >
//           <LazyImage
//             alt={title}
//             image={firstImage}
//             variants={variants}
//             sizes={renderSizes}
//             rootClassName={css.rootForImage}
//           />
//         </AspectRatioWrapper>

//         <div className={css.info}>
//           <button
//             onClick={toggleFavourites}
//             className={classNames(css.favouritesSpan, {
//               [css.favourited]: isFavourite,
//               [css.favouriteLoading]: favouriteLoading === id,
//             })}
//           >
//             <AiTwotoneHeart />
//           </button>

//           <div className={css.title}>
//             {richText(title, {
//               longWordClass: css.longWord,
//               longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
//             })}
//             <div className={css.viewMoreInfo}>
//               <NamedLink name="SearchPage">
//                 <FormattedMessage id="ListingCardNew.viewMoreInfo" />
//               </NamedLink>
//             </div>
//           </div>

//           {/* <div className={css.productRating}>
//             <div className={css.ratingIcons}>
//               {true ? (
//                 renderStars(3.4)
//               ) : (
//                 <React.Fragment>
//                   <FaRegStar />
//                   <FaRegStar />
//                   <FaRegStar />
//                   <FaRegStar />
//                   <FaRegStar />
//                 </React.Fragment>
//               )}
//             </div>
//             <div className={css.rating}>3.4</div>
//           </div> */}

//           <p className={css.descP}>
//             {richText(trimmedDescription, {
//               longWordClass: css.longWord,
//               longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
//             })}
//           </p>
//           {showAuthorInfo && <div className={css.authorVisibleFrom1200}>{authorContainer}</div>}

//           <div className={classNames(css.utility, css.visibleUtilitySection)}>
//             {showAuthorInfo && authorContainer}
//             <p className={css.locationP}>
//               <GrLocation />
//               <span>{address}</span>
//             </p>
//             <div className={css.uptoLargeScreens}>{buttonsContainer}</div>
//           </div>
//         </div>
//       </section>

//       <section className={classNames(css.utility, css.invisibleUtilitySection)}>
//         {showAuthorInfo && <div className={css.authorInvisibleFrom1200}>{authorContainer}</div>}
//         <p className={css.locationP}>
//           <GrLocation />
//           <span>{address}</span>
//         </p>
//         <div className={css.uptoLargeScreens}>{buttonsContainer}</div>
//       </section>
//     </article>
//   );
// };

// const mapStateToProps = state => {
//   const { favListingsIds } = state.FavouritesPage;
//   return { favListingsIds };
// };

// const mapDispatchToProps = dispatch => ({
//   onFetchFavListing: props => dispatch(fetchFavListing(props)),
//   onFetchCurrentUser: props => dispatch(fetchCurrentUser(props)),
// });

// export default compose(
//   withRouter,
//   injectIntl,
//   connect(
//     mapStateToProps,
//     mapDispatchToProps
//   )
// )(ListingCardNewComponent);
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import classNames from 'classnames';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { apiBaseUrl } from '../../util/api';
import { propTypes } from '../../util/types';
import { richText } from '../../util/richText';
import { createSlug, getDomain } from '../../util/urlHelpers';
import { ensureListing, ensureUser } from '../../util/data';
import { lazyLoadWithDimensions } from '../../util/uiHelpers';
import { createResourceLocatorString } from '../../util/routes';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';

import {
  AvatarSmall,
  AvatarMedium,
  ResponsiveImage,
  AspectRatioWrapper,
  NamedLink,
} from '../../components';

import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import css from './ListingCardNew.module.css';

import { FaStar } from 'react-icons/fa6';
import { FaRegStar } from 'react-icons/fa6';
import { GrLocation } from 'react-icons/gr';
import { AiTwotoneHeart } from 'react-icons/ai';
import { FaRegStarHalfStroke } from 'react-icons/fa6';
import { ReactComponent as GlobeSVG } from '../../assets/svg/globe.svg';
import { ReactComponent as PhoneSVG } from '../../assets/svg/phone.svg';
import { ReactComponent as VerifiedSVG } from '../../assets/svg/verified.svg';
import { ReactComponent as WhatsAppSVG } from '../../assets/svg/whats-app.svg';
import { ReactComponent as GetDirectionSVG } from '../../assets/svg/get-direction.svg';
import { ReactComponent as EmailSVG } from '../../assets/svg/email.svg';
import { ReactComponent as ShareSVG } from '../../assets/svg/share.svg';
import { ReactComponent as CommentSVG } from '../../assets/svg/comment.svg';
import { ReactComponent as LocationSVG } from '../../assets/svg/location.svg';
import { ReactComponent as ContactPersonSVG } from '../../assets/svg/contact-person.svg';
import { ReactComponent as InstagramSVG } from '../../assets/svg/instagram.svg';
import { ReactComponent as LinkedInSVG } from '../../assets/svg/linkedIn.svg';
import { ReactComponent as XSVG } from '../../assets/svg/x.svg';
import { ReactComponent as FacebookSVG } from '../../assets/svg/facebook.svg';
import { connect } from 'react-redux';
import { fetchFavListing } from '../../containers/FavouritesPage/FavouritesPage.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { useNativeLang } from '../../hooks/useNativeLang';

const DESC_MAX_WORDS = 80;
const MIN_LENGTH_FOR_LONG_WORDS = 10;

const renderStars = avgRating => {
  const stars = [];
  const halfStar = avgRating % 1 !== 0;
  const fullStars = Math.floor(avgRating);
  const emptyStars = 5 - Math.ceil(avgRating);

  for (let i = 0; i < fullStars; i++) {
    stars.push(<FaStar key={i} />);
  }

  if (halfStar) {
    stars.push(<FaRegStarHalfStroke key={fullStars} />);
  }

  for (let i = 0; i < emptyStars; i++) {
    stars.push(<FaRegStar key={fullStars + halfStar + i} />);
  }

  return stars;
};

const LazyImage = lazyLoadWithDimensions(ResponsiveImage, { loadAfterInitialRendering: 3000 });

export const ListingCardNewComponent = props => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const [isFavourite, setIsFavourite] = useState(null);
  const [favouriteLoading, setFavouriteLoading] = useState('');
  const {
    intl,
    author,
    history,
    listing,
    className,
    currentUser,
    renderSizes,
    rootClassName,
    showAuthorInfo = true,
    setActiveListing,
    onFetchFavListing,
    onFetchCurrentUser,
    favListingsIds,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureListing(listing);
  const id = currentListing.id.uuid;
  const { userNativeLang } = useNativeLang();

  // Author details
  const ensuredAuthor = ensureUser(author);
  const authorName = ensuredAuthor.attributes.profile.displayName;
  const ensuredAuthorPublicData = ensuredAuthor?.attributes?.profile?.publicData || {};
  const isPremiumVendor = ensuredAuthorPublicData?.isPremiumVendor;
  const services = ensuredAuthorPublicData?.services || [];
  const websiteLink = ensuredAuthorPublicData.websiteLink;
  const companyName = ensuredAuthorPublicData.companyName;
  const isProvider = ensuredAuthorPublicData?.isProvider;
  const trimmedServices =
    services?.length > 2 ? services?.slice(0, 2)?.concat({ label: '...' }) : services;

  // Listing details
  const {
    title: rawTitle = '',
    publicData,
    description: rawDesc = '',
    metadata,
  } = currentListing.attributes;
  const { trLang, trTitle, trDesc } = metadata || {};
  const title = (userNativeLang === trLang && trTitle) || rawTitle;
  const description = (userNativeLang === trLang && trDesc) || rawDesc;
  const slug = createSlug(title);
  const {
    firstName,
    lastName,
    email: contactPersonEmail,
    phoneNumber: { cpDialCode, cpCallNumber } = {},
    websiteLink: cpWebLink,
    socialMediaLink: cpMediaLink,
    linkedInLink: cpLinkedInLink,
    xHandle: cpXHandle,
    facebook: cpFacebook,
    phoneNumber: cpPhoneNumber,
    whatsAppNumber: cpWhatsAppNumber,
  } = publicData.contactPerson || {};

  const callNumber = cpPhoneNumber?.number;
  const callDialCode = cpPhoneNumber?.dialCode;
  const vendorCallNumber = `${callDialCode}${callNumber}`;
  const whatsAppNumber = cpWhatsAppNumber?.number;
  const whatsAppDialCode = cpWhatsAppNumber?.dialCode;
  const vendorWhatsAppNumber = `${whatsAppDialCode}${whatsAppNumber}`;

  const brandName = publicData?.brandName;
  const address = publicData?.locationFromUser?.selectedPlace?.address;
  const trimmedDescription =
    description?.length > DESC_MAX_WORDS
      ? description.slice(0, DESC_MAX_WORDS) + '...'
      : description;

  const firstImage =
    currentListing.images && currentListing.images.length > 0 ? currentListing.images[0] : null;

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith(variantPrefix))
    : [];

  const setActivePropsMaybe = setActiveListing
    ? {
        onMouseEnter: () => setActiveListing(currentListing.id),
        onMouseLeave: () => setActiveListing(null),
      }
    : null;

  const toggleFavourites = async e => {
    e.stopPropagation();
    setFavouriteLoading(id);
    const userId = currentUser?.id?.uuid;
    const toggleUrl = `${apiBaseUrl()}/api/favourites/toggle/${id}`;

    if (!userId) {
      return history.push(
        createResourceLocatorString('LoginPage', routeConfiguration, { tab: 'login' })
      );
    }

    return axios
      .get(toggleUrl, { withCredentials: true })
      .then(res => {
        res.data.message === 'Favourite added' ? setIsFavourite(true) : setIsFavourite(false);
        setFavouriteLoading('');
      })
      .then(() => {
        onFetchFavListing({ config });
      })
      .then(() => {
        onFetchCurrentUser();
      })
      .catch(err => {
        setFavouriteLoading('');
      });
  };
  const message = intl.formatMessage(
    { id: 'ListingCard.whatsAppLinkMsg' },
    { link: getDomain(process.env.REACT_APP_MARKETPLACE_ROOT_URL) }
  );
  const whatsAppMessage = encodeURIComponent(message);
  //Hello! I found your business in

  const authorContainer = (
    <div className={css.author}>
      <div className={css.authorAvatar}>
        <AvatarSmall
          user={ensuredAuthor}
          disableProfileLink={true}
          className={css.providerAvatarSmall}
        />
        <AvatarMedium
          user={ensuredAuthor}
          disableProfileLink={true}
          className={css.providerAvatarMedium}
        />
      </div>

      <div className={css.authorInformation}>
        {/* Business Name */}
        <div className={css.authorCompany}>
          <span>{companyName}</span>
          {isPremiumVendor && (
            <React.Fragment>
              <VerifiedSVG />
              <span className={css.authorIsVerified}>
                {intl.formatMessage({ id: 'ListingCard.verified' })}
              </span>
            </React.Fragment>
          )}
        </div>

        {isProvider && websiteLink ? (
          <div className={css.websiteLink} onClick={e => e.stopPropagation()}>
            <GlobeSVG
              onClick={e => {
                e.stopPropagation();

                if (window) {
                  window.open(websiteLink, '_blank');
                }
              }}
            />
            <a target="_blank" rel="noopener noreferrer" href={websiteLink}>
              {websiteLink}
            </a>
          </div>
        ) : null}

        {/* Provider Name */}
        {!isProvider && authorName && <div className={css.authorName}>{authorName}</div>}

        {/* Chips */}
        {services?.length ? (
          <div className={css.serviceChipContainer}>
            {/* {Array.from({ length: 12 }, () => trimmedServices).flat().map(service => ( */}
            {trimmedServices?.map(service => (
              <div key={service?.label || service}>{service?.label || service}</div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );

  const contactPerson =
    firstName && lastName ? (
      <React.Fragment>
        <div className={css.contactPerson}>
          <div className={css.authorCompany}>
            <span>{companyName}</span>
            {isPremiumVendor && (
              <React.Fragment>
                <VerifiedSVG />
                <span className={css.authorIsVerified}>
                  {intl.formatMessage({ id: 'ListingCard.verified' })}
                </span>
              </React.Fragment>
            )}
          </div>

          <h5>
            <FormattedMessage id="ProfileSettingsCustomForm.contactPerson" />
          </h5>

          <div className={css.contactPersonName}>
            <ContactPersonSVG />
            <span>
              {firstName} {lastName}
            </span>
          </div>

          {/* Email*/}
          {contactPersonEmail && (
            <div className={css.contactPersonEmail}>
              <EmailSVG />
              <a href={`mailto:${contactPersonEmail}`} className={css.anchorTag}>
                {contactPersonEmail}
              </a>
            </div>
          )}

          {/* Phone */}
          {cpDialCode && cpCallNumber && (
            <div className={css.contactPersonPhoneNumber}>
              <PhoneSVG />
              <a className={css.anchorTag} href={`tel:${contactPersonCallNumber}`}>
                {contactPersonCallNumber}
              </a>
            </div>
          )}
        </div>
        {isPremiumVendor ? (
          <div className={css.socialContainer}>
            {cpWebLink ? (
              <div>
                {/* <GlobeSVG className={css.contactIcon} /> */}
                <a
                  className={css.anchorTag}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={cpWebLink}
                  onClick={e => e.stopPropagation()}
                >
                  {/* {cpWebLink} */}
                  <GlobeSVG className={css.contactIcon} />
                </a>
              </div>
            ) : null}

            {/* Social Media Link */}
            {cpMediaLink ? (
              <div className={css.contactIconDiv}>
                {/* <ShareSVG /> */}
                <a
                  className={css.anchorTag}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={cpMediaLink}
                  onClick={e => e.stopPropagation()}
                >
                  <InstagramSVG className={css.contactIcon} />
                </a>
              </div>
            ) : null}

            {cpLinkedInLink ? (
              <div className={css.contactIconDiv}>
                <a
                  className={css.anchorTag}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={cpLinkedInLink}
                  onClick={e => e.stopPropagation()}
                >
                  <LinkedInSVG className={css.contactIcon} />
                </a>
              </div>
            ) : null}

            {cpXHandle ? (
              <div className={css.contactIconDiv}>
                <a
                  className={css.anchorTag}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={cpXHandle}
                  onClick={e => e.stopPropagation()}
                >
                  <XSVG className={css.contactIcon} />
                </a>
              </div>
            ) : null}
            {cpFacebook ? (
              <div className={css.contactIconDiv}>
                <a
                  className={css.anchorTag}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={cpFacebook}
                  onClick={e => e.stopPropagation()}
                >
                  <FacebookSVG className={classNames(css.contactIcon, css.facebookIcon)} />
                </a>
              </div>
            ) : null}
          </div>
        ) : null}
      </React.Fragment>
    ) : null;

  const buttonsContainer = (
    <div className={css.buttonWrapper}>
      <button
        className={css.getDirection}
        onClick={e => {
          e.stopPropagation();

          if (window) {
            window.open(`https://www.google.com/maps?q=${address}`, '_blank');
          }
        }}
      >
        <GetDirectionSVG />
        <FormattedMessage id="ListingCard.getDirectionButton" />
      </button>

      <button
        disabled={!(callDialCode && callNumber)}
        className={classNames(css.call, {
          [css.callNotAvailable]: !(callDialCode && callNumber),
        })}
        onClick={e => {
          e.stopPropagation();
          window.location.href = `tel:${vendorCallNumber}`;
        }}
      >
        <PhoneSVG />
        {callDialCode && callNumber ? (
          <a href={`tel:${vendorCallNumber}`} onClick={e => e.stopPropagation()}>
            {vendorCallNumber}
          </a>
        ) : (
          <FormattedMessage id="ListingCard.callNotAvailableButton" />
        )}
      </button>

      <button
        disabled={!(whatsAppDialCode && whatsAppNumber)}
        className={classNames(css.whatsapp, {
          [css.callNotAvailable]: !(whatsAppDialCode && whatsAppNumber),
        })}
        onClick={e => {
          e.stopPropagation();
          const url = `https://api.whatsapp.com/send?phone=${vendorWhatsAppNumber}&text=${whatsAppMessage}`;
          window.open(url, '_blank', 'noopener noreferrer');
        }}
      >
        <WhatsAppSVG />
        {whatsAppDialCode && whatsAppNumber ? (
          <a
            target="_blank"
            rel="noopener noreferrer"
            onClick={e => e.stopPropagation()}
            href={`https://api.whatsapp.com/send?phone=${vendorWhatsAppNumber}&text=${whatsAppMessage}`}
          >
            <FormattedMessage id="ListingCard.whatsApp" />
          </a>
        ) : (
          <FormattedMessage id="ListingCard.callNotAvailableButton" />
        )}
      </button>

      <button className={css.sendEnquiry}>
        <FormattedMessage id="ListingCard.sendEnquiryButton" />
      </button>
    </div>
  );

  useEffect(() => {
    if (isFavourite === null && currentUser?.id?.uuid) {
      currentUser.favourites?.includes(id) ? setIsFavourite(true) : setIsFavourite(false);
    }
  }, [currentUser]);

  return (
    <article
      className={classes}
      onClick={e => {
        history.push(createResourceLocatorString('ListingPage', routeConfiguration, { id, slug }));
      }}
    >
      <section className={css.content}>
        <AspectRatioWrapper
          width={aspectWidth}
          height={aspectHeight}
          className={css.aspectRatioWrapper}
          {...setActivePropsMaybe}
        >
          <LazyImage
            alt={title}
            image={firstImage}
            variants={variants}
            sizes={renderSizes}
            rootClassName={css.rootForImage}
          />
        </AspectRatioWrapper>

        <div className={css.info}>
          <button
            onClick={toggleFavourites}
            className={classNames(css.favouritesSpan, {
              [css.favourited]: isFavourite,
              [css.favouriteLoading]: favouriteLoading === id,
            })}
          >
            <AiTwotoneHeart />
          </button>

          <div className={css.title}>
            {richText(title, {
              longWordClass: css.longWord,
              longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
            })}
            <div className={css.viewMoreInfo}>
              <NamedLink name="SearchPage">
                <FormattedMessage id="ListingCardNew.viewMoreInfo" />
              </NamedLink>
            </div>
          </div>

          {/* <div className={css.productRating}>
            <div className={css.ratingIcons}>
              {true ? (
                renderStars(3.4)
              ) : (
                <React.Fragment>
                  <FaRegStar />
                  <FaRegStar />
                  <FaRegStar />
                  <FaRegStar />
                  <FaRegStar />
                </React.Fragment>
              )}
            </div>
            <div className={css.rating}>3.4</div>
          </div> */}

          <p className={css.descP}>
            {richText(trimmedDescription, {
              longWordClass: css.longWord,
              longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
            })}
          </p>
          {/* {showAuthorInfo && <div className={css.authorVisibleFrom1200}>{authorContainer}</div>} */}

          <div className={css.authorVisibleFrom1200}>{contactPerson}</div>

          <div className={classNames(css.utility, css.visibleUtilitySection)}>
            {/* {showAuthorInfo && authorContainer} */}
            {contactPerson}
            <p className={css.locationP}>
              <GrLocation />
              <span>{address}</span>
            </p>
            <div className={css.uptoLargeScreens}>{buttonsContainer}</div>
          </div>
        </div>
      </section>

      <section className={classNames(css.utility, css.invisibleUtilitySection)}>
        {/* {showAuthorInfo && <div className={css.authorInvisibleFrom1200}>{authorContainer}</div>} */}
        <div className={css.authorInvisibleFrom1200}>{contactPerson}</div>
        <p className={css.locationP}>
          <GrLocation />
          <span>{address}</span>
        </p>
        <div className={css.uptoLargeScreens}>{buttonsContainer}</div>
      </section>
    </article>
  );
};

const mapStateToProps = state => {
  const { favListingsIds } = state.FavouritesPage;
  return { favListingsIds };
};

const mapDispatchToProps = dispatch => ({
  onFetchFavListing: props => dispatch(fetchFavListing(props)),
  onFetchCurrentUser: props => dispatch(fetchCurrentUser(props)),
});

export default compose(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(ListingCardNewComponent);
